import * as types from '../constants/ActionTypes';
import api from '../../config/api.js';

export function fetchParentPatientRecords(parentId) {
	return (dispatch) => {
		console.log('getting parent patients')
		if(!parentId) return Promise.reject('no parent id')
		return api.get(`/patients/records/parent/${parentId}`)
		.then(d => {
			if(d.data){
				dispatch({
				 type: types.SET_PATIENT_RECORDS,
				 payload: d.data
			 })
			 	return Promise.resolve(d.data)
		 	}else{
				 console.log('No data');
			 throw new Error('No data');
		 	}

		})
		.catch(e => {
			dispatch({
			 type: types.SET_PATIENT_RECORDS,
			 payload: {}
		 })
			console.log('Error getting patient for parent from server', e)
			return Promise.reject(e)
		})
	}
}

export const updateSessionParentOpenToRead = (patientRecord, sessionId) => {
	return (dispatch) => {
		if (!sessionId) return Promise.reject('no session id')
		return api.get(`/patients/sessions/${patientRecord}/${sessionId}/parent/opened`)
		.then(d => {
				if (d.data) {
					if (d.data.parent_opened) {
						console.log('Parent open session to read.')
					}
				}
			})
			.catch(e => {
				console.log('Error getting updating session for parent open to read', e)
				return Promise.reject(e)
			})
	}
}

export const emailParentAssignPatient = (parentId, patientId, practiceId) => {
	return api.post('/patients/send_assigned_parent_email', {parentId, patientId, practiceId})
}



// WEBPACK FOOTER //
// ./src/actions/parent.js